import VueCookies from 'vue-cookies';
// Appsflyer.js
export const ONELINK_URL = 'https://travelist.onelink.me/VSoR';

export const PIDS = {
  cart: 'web_cart',
  cart_mileage: 'web_cart_mileage',
  cart_onlinecheckin: 'web_cart_onlinecheckin',
  cart_modal_from_meta: 'web_cart_modal_from_meta',
  cart_modal_not_from_meta: 'web_cart_modal_not_from_meta',
  web_browser_switch_modal: 'web_browser_switch_modal',
  smart_banner: 'smart_banner',
  web_header_modal: 'web_header_modal',
};

// 共通のOneLink URL生成関数
export const createOneLinkUrl = (pid, deepLinkValue = '', media = null) => {
  const params = new URLSearchParams({
    af_xp: 'custom',
    pid: pid,
    af_dp: 'jp.co.travelonline.airtown://',
  });

  // deep_link_value が指定されている場合に追加
  if (deepLinkValue) {
    let finalDeepLinkValue = deepLinkValue;

    // deep_link_valueがURLの場合、med_idをクエリパラメータとして追加
    if (
      media &&
      typeof deepLinkValue === 'string' &&
      deepLinkValue.startsWith('http')
    ) {
      try {
        const url = new URL(deepLinkValue);
        url.searchParams.set('med_id', media);
        finalDeepLinkValue = url.toString();
      } catch (e) {
        finalDeepLinkValue = deepLinkValue;
      }
    }
    // deep_link_valueがJSONの場合、med_idをオブジェクトに追加
    else if (
      media &&
      typeof deepLinkValue === 'string' &&
      deepLinkValue.startsWith('{')
    ) {
      try {
        const deepLinkData = JSON.parse(deepLinkValue);
        deepLinkData.med_id = media;
        finalDeepLinkValue = JSON.stringify(deepLinkData);
      } catch (e) {
        finalDeepLinkValue = deepLinkValue;
      }
    }

    params.append('deep_link_value', finalDeepLinkValue);
  }

  // 以下は既存のまま
  const gbraid = VueCookies.get('gbraid');
  const gclid = VueCookies.get('gclid');

  if (gbraid) {
    params.append('af_sub1', gbraid);
  }
  if (gclid) {
    params.append('af_sub2', gclid);
  }
  if (media) {
    params.append('af_channel', media);
  }

  return `${ONELINK_URL}?${params.toString()}`;
};
